const twLang = {
  header: {
    setting: '设置',
    fullScreen: '全屏',
    exitFullscreen: '退出全屏',
    userCenter: '个人中心',
    logout: '退出账号',
    langLabel: '语言',
    zhTip: '中文',
    enTip: '英语',
    jaTip: '日语',
    koTip: '韩语'
  },
  home: {
    welcome: '欢迎使用比翼后台管理系统模板工程',
    versionDoc: '新版本文档说明'
  },
  placeholderText: '请输入文字...',
  placeholderDate: '选择日期',
  submitText: '提交',
  cancelText: '取消',
  resetText: '重置',
  enterText: '请输入',
  searchText: '搜索',
  newText: '新建',
  editText: '编辑',
  deleteText: '删除',
  operateText: '操作',
  deletePopTip: '您确定要删除这条数据吗?',
  successText: '提交成功',
  errorText: '提交失败',
  holder: '请输入',
  required: '必填'
}

export default twLang
